module.exports = __webpack_public_path__ + "img/573-42dfb3.png";